// Adapted from https://github.com/nuxt/image/blob/be1e3bfe6b8de720734392928aa49980e6ce8c77/src/runtime/providers/ipx.ts

import { encodeParam, encodePath, joinURL } from 'ufo'
import type { ImageModifiers, ProviderGetImage } from '@nuxt/image'
import { createOperationsGenerator } from '#image'

const operationsGenerator = createOperationsGenerator({
  keyMap: {
    format: 'f',
    fit: 'fit',
    width: 'w',
    height: 'h',
    resize: 's',
    quality: 'q',
    background: 'b',
  },
  joinWith: '&',
  formatter: (key, val) => `${encodeParam(key)}_${encodeParam(val)}`,
})

interface ProviderOptions {
  modifiers?: Partial<ImageModifiers>
  baseURL?: string
  basePath?: string
}

export const getImage: ProviderGetImage = (src, { modifiers = {}, baseURL, basePath }: ProviderOptions = {}, ctx) => {
  if (modifiers.width && modifiers.height) {
    modifiers.resize = `${modifiers.width}x${modifiers.height}`
    delete modifiers.width
    delete modifiers.height
  }

  const params = operationsGenerator(modifiers) || '_'

  if (!baseURL) {
    // eslint-disable-next-line no-param-reassign
    baseURL = joinURL(ctx.options.nuxt.baseURL, basePath ?? '/api/img')
  }

  return {
    url: joinURL(baseURL, params, encodePath(src)),
  }
}

export const validateDomains = true
export const supportsAlias = true
